export default __webpack_public_path__ + "static/media/redem.fcc73ee1.svg";